var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestType({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 144,
    viewBox: "0 0 142 144",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.213)",
    stroke: "#D2D2D9",
    strokeWidth: 2.7,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EEF0F3",
    cx: 104.67,
    cy: 106.435,
    rx: 36.942,
    ry: 37.565
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.67 87.652v37.565M123.141 106.435H86.198M30.785 106.435h24.628M0 68.87h67.727M49.256 87.652v9.391c0 5.187-4.135 9.392-9.235 9.392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.14 56.348V6.26c0-3.458-2.756-6.261-6.156-6.261H6.157C2.757 0 0 2.803 0 6.26v75.131c0 3.458 2.757 6.261 6.157 6.261h49.256"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestType);
export default __webpack_public_path__ + "static/media/request-type.6bda75fa9c4f2f6c4772b2fc79031b13.svg";
export { ForwardRef as ReactComponent };